import clsx from 'clsx';
import {Trans} from '../../i18n/trans';
import {CheckIcon} from '../../icons/material/Check';
import {Product} from '../product';

interface FeatureListProps {
  product: Product;
  showSectionTitle?: boolean;
  variant?: 'default' | 'pricing' | 'pricing-yearly';
}

export function ProductFeatureList({
  product,
  showSectionTitle = true,
  variant = 'default',
}: FeatureListProps) {
  if (!product.feature_list.length) return null;

  if (variant === 'pricing' || variant === 'pricing-yearly') {
    return (
      <div className="mt-8 w-full min-w-0">
        {showSectionTitle ? (
          <div className="mb-9 text-left text-[12px] font-bold leading-normal text-[#535353] dark:text-[#b3bcc8]">
            <Trans message="What's included" />
          </div>
        ) : null}
        <ul className="m-0 w-full list-none space-y-[4px] p-0 text-center leading-snug">
          {product.feature_list.map((feature, i) => (
            <li
              key={feature}
              className={clsx(
                'text-[15px] leading-snug text-[#535353] dark:text-[#b3bcc8]',
                i === 0 ? 'font-bold' : 'font-normal'
              )}
            >
              <Trans message={feature} />
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="mt-32 border-t pt-24">
      {showSectionTitle ? (
        <div className="mb-10 text-sm font-semibold">
          <Trans message="What's included" />
        </div>
      ) : null}
      {product.feature_list.map(feature => (
        <div key={feature} className="flex items-center gap-10 py-6 text-sm">
          <CheckIcon className="text-positive" size="sm" />
          <Trans message={feature} />
        </div>
      ))}
    </div>
  );
}
